import { BUSINESS_MANAGER, GROUP_MANAGER, ORG_ADMIN, ORG_MANAGER } from 'app/common/data/roles';
import useMe from 'app/common/hooks/queries/useMeUncamel';

export const useHasHomepage = (): {
    hasHomepage: boolean;
    isLoading: boolean;
} => {
    const { data: me, isLoading } = useMe();
    const hasCorrectRole = [BUSINESS_MANAGER, GROUP_MANAGER, ORG_MANAGER, ORG_ADMIN].includes(me?.role ?? '');

    return {
        hasHomepage: hasCorrectRole,
        isLoading,
    };
};
